import { useContext } from "react";
import { ProviderNetworkImportContext } from "../providerNetworksImportContext";
import ProviderNetworkImportService from "../services/providerNetworkImportService";
import { ImportSagaState } from "../state";
import { ImportSagaAction } from "./../actions";

interface UseImportSaga {
  loadSagaState: (versionId: number) => Promise<void>;
  saga: ImportSagaState;
}

export function useImportSaga(): UseImportSaga {
  const { sagaDispatch, saga } = useContext(ProviderNetworkImportContext);
  const importService = new ProviderNetworkImportService();

  const loadSagaState = async (versionId: number) => {
    sagaDispatch({ type: ImportSagaAction.LoadSaga, versionId });
    const result = await importService.getImportState(versionId);
    sagaDispatch({ result, type: ImportSagaAction.LoadSagaSuccess });
  };

  return { loadSagaState, saga };
}
